import { forwardRef } from 'react';
import { List, ListItem, ListItemContent } from './styled-components';

type StepperItem = {
  id: string | number;
  content: React.ReactNode;
};

type Props = React.DetailedHTMLProps<React.OlHTMLAttributes<HTMLOListElement>, HTMLOListElement> & {
  items: StepperItem[];
};

export const Stepper = forwardRef<HTMLOListElement, Props>(({ items, ...props }, ref) => (
  <List ref={ref} {...props}>
    {items.map(({ id, content }) => (
      <ListItem key={id}>
        <ListItemContent>{content}</ListItemContent>
      </ListItem>
    ))}
  </List>
));
